var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('th',{class:['sort-header', { sorted: _vm.sorted }],style:({width: _vm.thWidth}),attrs:{"scope":"col"},on:{"click":_vm.sort}},[_vm._t("default"),_c('span',{staticClass:"sh-arrow"},[_c('span',{class:("fas fa-fw fa-" + _vm.icon)})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }